import videojs, { VideoJsPlayer } from 'video.js';

import PlayerManager, { playerManager } from '@src/controllers/PlayerManager';
import type { IPlayerProxy } from '@src/controllers/PlayerManager';
import PlayerError, { ErrorCause, ErrorMessage } from '@src/errors/PlayerError';
import { Event } from '@src/types/event';
import { generateAdCustomParamsString } from '@src/utils/ads';

const createPlayerAsync =
  playerManager?.createPlayerAsync.bind(playerManager) ?? null;

export type { IPlayerProxy, VideoJsPlayer };

export {
  Event,
  playerManager,
  PlayerManager,
  videojs,
  createPlayerAsync,
  PlayerError,
  ErrorMessage,
  ErrorCause,
  generateAdCustomParamsString,
};
